import * as yup from 'yup';

export const examAssignmentSchema = yup.object().shape({
    gradeLevelMasterId: yup.number().required().min(1, 'Please select a grade level'),
    examTypeMasterId: yup.number().required().min(1, 'Please select an assessment type'),
    examId: yup.number().required().min(1, 'Please select an assessment'),
    districtId: yup.number().required().min(1, 'Please select a district'),
    schoolId: yup.number().required().min(1, 'Please select a school'),
    classes: yup
        .array()
        .of(
            yup.object().shape({
                classId: yup.number().required().min(1, 'Please select a class'),
                studentIds: yup.array().required().min(1, 'Please select at least one student'),
                teacherIds: yup.array().required().min(1, 'Please select at least one teacher'),
                students: yup.array().of(
                    yup.object().shape({
                        id: yup.number().required(),
                        name: yup.string().required(),
                    })
                ),
                teachers: yup.array().of(
                    yup.object().shape({
                        id: yup.number().required(),
                        name: yup.string().required(),
                    })
                ),
            })
        )
        .min(1, 'Please add at least one class'),
    numberOfAttemptsAllowed: yup
        .number()
        .required()
        .min(1, 'Number of attempts must be at least 1')
        .max(5, 'Number of attempts cannot exceed 5'),
    isSpanishAllowed: yup.boolean().required(),
    duration: yup.number().required().min(0, 'Duration cannot be negative.'),
    fromDTUTC: yup
        .date()
        .required('Start date is required')
        .typeError('Date must be in the format MM/DD/YYYY hh:mm:ss AM/PM'),
    toDTUTC: yup
        .date()
        .required('End date is required')
        .typeError('Date must be in the format MM/DD/YYYY hh:mm:ss AM/PM')
        .min(yup.ref('fromDTUTC'), 'End date must be after start date'),
});
